import { render, staticRenderFns } from "./BulmaChartjs.vue?vue&type=template&id=3f233d0a&scoped=true"
import script from "./BulmaChartjs.vue?vue&type=script&lang=js"
export * from "./BulmaChartjs.vue?vue&type=script&lang=js"
import style0 from "./BulmaChartjs.vue?vue&type=style&index=0&id=3f233d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f233d0a",
  null
  
)

export default component.exports